import { render, staticRenderFns } from "./PaginationFilterSort.vue?vue&type=template&id=95fdc71a&scoped=true"
import script from "./PaginationFilterSort.vue?vue&type=script&lang=js"
export * from "./PaginationFilterSort.vue?vue&type=script&lang=js"
import style0 from "./PaginationFilterSort.vue?vue&type=style&index=0&id=95fdc71a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95fdc71a",
  null
  
)

export default component.exports